// extracted by mini-css-extract-plugin
export default {"tabsBox":"EjjR_UCCuQ4Egey2EBSw","addMealButton":"rIO5iexyB35nCKnHpylc"};